module.exports = __webpack_public_path__ + "img/197865920864520_image.jpg";